/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Web_Scraping_Antibot_Desc7Inputs */

const en_svc_web_scraping_antibot_desc7 = /** @type {(inputs: Svc_Web_Scraping_Antibot_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proxy rotation, fingerprint management, and CAPTCHA handling for sites engineered to resist scraping.`)
};

const ar_svc_web_scraping_antibot_desc7 = /** @type {(inputs: Svc_Web_Scraping_Antibot_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تدوير بروكسي وإدارة بصمات ومعالجة CAPTCHA لمواقع مصممة لمقاومة السكرابينغ.`)
};

const bn_svc_web_scraping_antibot_desc7 = /** @type {(inputs: Svc_Web_Scraping_Antibot_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রক্সি রোটেশন, ফিঙ্গারপ্রিন্ট ম্যানেজমেন্ট ও ক্যাপচা হ্যান্ডলিং, স্ক্র্যাপিং ঠেকাতে তৈরি করা সাইটগুলোর জন্য।`)
};

const de_svc_web_scraping_antibot_desc7 = /** @type {(inputs: Svc_Web_Scraping_Antibot_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proxy-Rotation, Fingerabdruckverwaltung und CAPTCHA-Verwaltung für Websites, die so konzipiert sind, dass sie Scraping widerstehen.`)
};

const es_svc_web_scraping_antibot_desc7 = /** @type {(inputs: Svc_Web_Scraping_Antibot_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rotación de proxies, gestión de huellas digitales y manejo de CAPTCHA para sitios diseñados para resistir el scraping.`)
};

const fr_svc_web_scraping_antibot_desc7 = /** @type {(inputs: Svc_Web_Scraping_Antibot_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rotation des proxys, gestion des empreintes digitales et gestion des CAPTCHA pour les sites conçus pour résister au scraping.`)
};

const pt_svc_web_scraping_antibot_desc7 = /** @type {(inputs: Svc_Web_Scraping_Antibot_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rotação de proxies, gestão de fingerprints e manejo de CAPTCHA para sites feitos para resistir ao scraping.`)
};

const zh_svc_web_scraping_antibot_desc7 = /** @type {(inputs: Svc_Web_Scraping_Antibot_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`代理轮换、指纹管理和验证码处理，适用于旨在抵抗抓取的网站。`)
};

const tr_svc_web_scraping_antibot_desc7 = /** @type {(inputs: Svc_Web_Scraping_Antibot_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kazınmaya karşı dayanıklı olacak şekilde tasarlanmış siteler için proxy rotasyonu, parmak izi yönetimi ve CAPTCHA yönetimi.`)
};

const ru_svc_web_scraping_antibot_desc7 = /** @type {(inputs: Svc_Web_Scraping_Antibot_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ротация прокси, менеджмент фингерпринтов и решение капч для сайтов, заточенных против скрапинга.`)
};

const pl_svc_web_scraping_antibot_desc7 = /** @type {(inputs: Svc_Web_Scraping_Antibot_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rotacja proxy, zarządzanie fingerprintami i obsługa CAPTCHA dla stron zaprojektowanych przeciw scrapingowi.`)
};

/**
* | output |
* | --- |
* | "Proxy rotation, fingerprint management, and CAPTCHA handling for sites engineered to resist scraping." |
*
* @param {Svc_Web_Scraping_Antibot_Desc7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_web_scraping_antibot_desc7 = /** @type {((inputs?: Svc_Web_Scraping_Antibot_Desc7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Web_Scraping_Antibot_Desc7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_web_scraping_antibot_desc7(inputs)
	if (locale === "bn") return bn_svc_web_scraping_antibot_desc7(inputs)
	if (locale === "de") return de_svc_web_scraping_antibot_desc7(inputs)
	if (locale === "es") return es_svc_web_scraping_antibot_desc7(inputs)
	if (locale === "fr") return fr_svc_web_scraping_antibot_desc7(inputs)
	if (locale === "pt") return pt_svc_web_scraping_antibot_desc7(inputs)
	if (locale === "zh") return zh_svc_web_scraping_antibot_desc7(inputs)
	if (locale === "tr") return tr_svc_web_scraping_antibot_desc7(inputs)
	if (locale === "ru") return ru_svc_web_scraping_antibot_desc7(inputs)
	if (locale === "pl") return pl_svc_web_scraping_antibot_desc7(inputs)
	return en_svc_web_scraping_antibot_desc7(inputs)
});
export { svc_web_scraping_antibot_desc7 as "svc_web-scraping_ANTIBOT_desc" }